import { defineComponent as Ce, useId as Se, ref as J, useSlots as ke, computed as u, watch as A, onMounted as Be, onUnmounted as xe, openBlock as d, createElementBlock as b, normalizeClass as c, createElementVNode as g, unref as D, Fragment as we, renderList as De, normalizeStyle as Le, createBlock as Q, createCommentVNode as m, toDisplayString as Pe, renderSlot as L, nextTick as ze } from "vue";
import Ie from "../../icons/generated/IconCheckInCircleFilled.vue2.js";
import { isEmpty as y } from "../../utils/isEmpty.js";
import { tw as t } from "../../utils/tailwind.js";
import { ColorsByVariant as i } from "./StatusTracker.constant.js";
import Ne from "./components/Hint.vue2.js";
const $e = ["aria-describedby", "aria-label", "aria-labelledby", "aria-valuetext"], Te = ["id"], Re = ["aria-current"], Ae = { class: "inline-flex items-center gap-x-4" }, Ee = { key: 0 }, Ue = { key: 1 }, Ve = {
  key: 1,
  class: "text-static-default-low caption"
}, Fe = 5, E = 6, Z = 4, U = 2, We = 0, je = /* @__PURE__ */ Ce({
  name: "RevStatusTracker",
  __name: "StatusTracker",
  props: {
    currentStep: {},
    orientation: { default: "horizontal" },
    progressBarColor: { default: "success" },
    startWith: { default: "first" },
    steps: {},
    ariaLabel: {},
    ariaLabelledby: {}
  },
  setup(s) {
    const V = Se(), F = J(null), W = J(null), P = ke();
    function x(e) {
      return s.steps.findIndex((a) => a.key === e);
    }
    function w(e) {
      if (!s.currentStep)
        return !1;
      const a = x(s.currentStep) || 0;
      return (x(e.key) || 0) < a;
    }
    function v(e) {
      return e.key === s.currentStep;
    }
    const _ = u(() => s.currentStep ? (x(s.currentStep) || 0) !== s.steps.length - 1 : !1), z = u(() => s.orientation === "horizontal"), f = u(() => s.orientation === "vertical"), C = u(() => s.startWith === "last"), h = u(() => C.value ? [...s.steps].reverse() : s.steps);
    function I(e) {
      return e.key === h.value[0].key;
    }
    function N(e) {
      return e.key === h.value[h.value.length - 1].key;
    }
    const ee = t`overflow-x-hidden supports-[overflow-x:clip]:overflow-x-clip`, te = t`overflow-y-hidden supports-[overflow-y:clip]:overflow-y-clip`;
    function $(e) {
      return w(e) ? Fe : v(e) ? E : Z;
    }
    function re(e) {
      return w(e) || v(e) ? U : We;
    }
    const se = u(() => {
      const e = [
        t`absolute`,
        t`[--mask-radius:calc(var(--disc-radius)+var(--disc-gap))]`,
        t`[mask-composite:exclude]`
      ], a = [
        t`inset-x-0 top-0 h-2 -translate-y-1/2 border-t-2`,
        t`[mask-image:radial-gradient(circle_at_var(--disc-origin),transparent_var(--mask-radius),black_var(--mask-radius))]`
      ], r = [
        t`left-0 w-2 -translate-x-1/2 border-l-2`,
        t`[mask-image:radial-gradient(circle_at_1px_var(--disc-origin),transparent_var(--mask-radius),black_var(--mask-radius))]`
      ];
      return h.value.map((n) => {
        const o = [], l = [], p = [], k = v(n), B = w(n), Y = I(n), ye = N(n);
        return z.value ? (B ? o.push(i[s.progressBarColor].progressBar.on.bar) : k ? (l.push(
          t`before:absolute before:bottom-0 before:left-0 before:block before:h-2 before:w-[--disc-origin] before:border-t-2 ${i[s.progressBarColor].progressBar.on.before}`
        ), o.push(i[s.progressBarColor].progressBar.off.bar)) : o.push(i[s.progressBarColor].progressBar.off.bar), C.value && (Y ? l.push(t`before:w-full`) : l.push(t`before:origin-right before:rotate-180`))) : (l.push(
          t`inset-y-0 border-transparent`,
          t`before:absolute before:right-0 before:block before:w-2 before:border-l-2 before:content-['']`,
          t`before:bottom-[calc(100%-var(--disc-origin))] before:top-0`,
          t`after:absolute after:right-0 after:block after:w-2 after:border-l-2 after:content-['']`,
          t`after:bottom-0 after:top-[--disc-origin]`
        ), Y ? l.push(t`before:hidden`) : ye && l.push(t`after:hidden`), B ? (o.push(
          i[s.progressBarColor].progressBar.on.before
        ), o.push(
          i[s.progressBarColor].progressBar.on.after
        )) : k ? C.value ? (o.push(
          i[s.progressBarColor].progressBar.off.before
        ), o.push(
          i[s.progressBarColor].progressBar.on.after
        )) : (o.push(
          i[s.progressBarColor].progressBar.on.before
        ), o.push(
          i[s.progressBarColor].progressBar.off.after
        )) : (o.push(
          i[s.progressBarColor].progressBar.off.before
        ), o.push(
          i[s.progressBarColor].progressBar.off.after
        ))), [
          e,
          o,
          l,
          p,
          f.value ? r : a
        ];
      });
    }), ae = u(() => {
      const e = t`rounded-full absolute`;
      return h.value.map((a) => {
        const r = [t`-translate-y-1/2`], n = [t`size-[calc(var(--disc-radius)*2)]`], o = [], l = v(a), p = w(a), k = I(a), B = N(a);
        return p ? (o.push(t`border-transparent`), n.push(t`[border-width:var(--disc-radius)]`)) : l ? (o.push(i[s.progressBarColor].progressBar.on.bar), n.push(t`[border-width:var(--disc-radius)]`)) : (o.push(i[s.progressBarColor].progressBar.off.bar), n.push(t`border-2`)), z.value ? (r.push(t`top-0`), k ? r.push(t`left-0`) : B ? r.push(t`right-0`) : r.push(t`left-1/2 -translate-x-1/2`)) : r.push(t`left-0 top-[--disc-origin] -translate-x-1/2`), [e, r, n, o];
      });
    }), oe = u(() => {
      const e = [t`body-2 relative`], a = [
        t`px-12 pt-18 text-center`,
        t`first:pl-0 first:text-left last:pr-0 last:text-right`
      ], r = t`flex justify-between gap-x-72 pb-24 pl-16 text-left`;
      return h.value.map((n) => {
        const o = [], l = I(n), p = N(n);
        return z.value ? l ? o.push(t`[--disc-origin:var(--disc-radius)]`) : p ? o.push(
          t`[--disc-origin:calc(100%-var(--disc-radius))]`
        ) : o.push(t`[--disc-origin:50%]`) : o.push(t`[--disc-origin:10px]`), [
          e,
          o,
          f.value ? r : a
        ];
      });
    }), ne = u(() => {
      const e = t`relative grid list-none`, a = t`auto-cols-fr grid-flow-col`, r = t`grid-cols-1`;
      return f.value ? [e, r] : [e, a, "overflow-wrap-anywhere"];
    }), le = u(() => {
      const e = [
        t`absolute z-[1]`,
        t`after:absolute after:block after:transition-transform after:content-['']`,
        i[s.progressBarColor].progressBar.on.after
      ], a = [
        t`-top-1 left-[--pulse-bar-origin-x] h-2 w-[--pulse-bar-width] translate-x-[--pulse-bar-offset]`,
        t`after:top-0 after:h-2 after:w-full after:animate-horizontal-pulse after:border-t-2`,
        C.value && t`origin-[calc(0%-var(--pulse-bar-offset))] rotate-180`,
        ee
      ], r = [
        t`-left-1 top-[--pulse-bar-origin-y] h-[--pulse-bar-height] w-2 translate-y-[--pulse-bar-offset]`,
        t`after:left-0 after:h-full after:w-2 after:animate-vertical-pulse after:border-l-2`,
        C.value && t`left-1 origin-[0_calc(0%-var(--pulse-bar-offset))] rotate-180`,
        te
      ];
      return [e, f.value ? r : a];
    }), ie = u(() => {
      const e = t`relative isolate`, a = t`mt-8`, r = t`ml-8`;
      return [e, f.value ? r : a];
    }), ue = u(
      () => f.value ? t`text-right` : ""
    );
    function ce(e) {
      return v(e) ? "step" : void 0;
    }
    const fe = u(
      () => s.steps.find((e) => v(e))?.label
    );
    function G(e) {
      return `${e.key}-date`;
    }
    function H(e) {
      return `${e.key}-details`;
    }
    function T(e) {
      return `${e.key}-link`;
    }
    function O(e) {
      return `${e.key}-content`;
    }
    const de = u(() => t`size-12 -translate-x-1/2 -translate-y-1/2`);
    function pe(e) {
      return [t`line-clamp-2`, v(e) && t`body-2-bold`];
    }
    function be(e) {
      return [v(e) && f.value && t`body-2-bold`];
    }
    const X = t`text-action-default-hi caption-link`;
    function q(e) {
      const a = x(e.key), r = C.value ? s.steps.length - 1 - a : a, n = W.value[r], o = n.offsetTop + 10, { offsetLeft: l, offsetWidth: p } = n;
      return r === 0 ? f.value ? o : l + $(e) : r === s.steps.length - 1 ? f.value ? o : l + p - $(e) : f.value ? o : l + p / 2;
    }
    async function S() {
      window.requestAnimationFrame && (await ze(), window.requestAnimationFrame(() => {
        const e = F.value;
        if (!e)
          return;
        const a = x(s.currentStep), r = "--pulse-bar-offset";
        let n = "--pulse-bar-origin-x", o = "--pulse-bar-width";
        if (f.value && (n = "--pulse-bar-origin-y", o = "--pulse-bar-height"), a === s.steps.length - 1 || y(s.steps) || y(s.currentStep)) {
          e.style.setProperty(n, "0"), e.style.setProperty(o, "0");
          return;
        }
        const l = q(s.steps[a]), p = q(
          s.steps[a + 1]
        ), k = Math.abs(p - l) - U - Z - E, B = U + E;
        e.style.setProperty(
          n,
          `${l}px`
        ), e.style.setProperty(r, `${B}px`), e.style.setProperty(o, `${k}px`);
      }));
    }
    function ve(e) {
      return !y(e.hint);
    }
    function M(e) {
      const a = G(e);
      return !y(P[a]);
    }
    function j(e) {
      const a = H(e);
      return !y(P[a]);
    }
    function R(e) {
      const a = T(e);
      return !y(P[a]);
    }
    function K(e) {
      const a = O(e);
      return !y(P[a]);
    }
    function he(e) {
      return !K(e) && (M(e) || j(e) || R(e));
    }
    function ge(e) {
      return R(e) && z.value;
    }
    function me(e) {
      return R(e) && f.value;
    }
    return A(
      () => s.currentStep,
      () => {
        S();
      }
    ), A(
      () => s.orientation,
      () => {
        S();
      }
    ), A(
      () => s.steps,
      () => {
        S();
      },
      { deep: !0 }
    ), Be(() => {
      window.addEventListener("resize", S), S();
    }), xe(() => {
      window.removeEventListener("resize", S);
    }), (e, a) => (d(), b("div", {
      ref_key: "elementRef",
      ref: F,
      class: c(ie.value)
    }, [
      g("div", {
        "aria-describedby": D(V),
        "aria-label": s.ariaLabel,
        "aria-labelledby": s.ariaLabelledby,
        "aria-valuetext": fe.value,
        class: c(_.value && le.value),
        role: "progressbar"
      }, null, 10, $e),
      g("ol", {
        id: D(V),
        class: c(ne.value)
      }, [
        (d(!0), b(we, null, De(h.value, (r, n) => (d(), b("li", {
          key: r.key,
          ref_for: !0,
          ref_key: "stepRefs",
          ref: W,
          "aria-current": ce(r),
          class: c(oe.value[n]),
          style: Le({
            "--disc-radius": `${$(r)}px`,
            "--disc-gap": `${re(r)}px`
          })
        }, [
          g("div", {
            class: c(se.value[n])
          }, null, 2),
          g("div", {
            class: c([ae.value[n], D(i)[s.progressBarColor].icon])
          }, [
            w(r) ? (d(), Q(D(Ie), {
              key: 0,
              class: c(de.value)
            }, null, 8, ["class"])) : m("", !0)
          ], 2),
          g("div", {
            class: c(["w-full", D(i)[s.progressBarColor].color])
          }, [
            g("div", Ae, [
              g("p", {
                class: c(pe(r))
              }, Pe(r.label), 3),
              r.hint && ve(r) ? (d(), Q(Ne, {
                key: 0,
                content: r.hint
              }, null, 8, ["content"])) : m("", !0)
            ]),
            K(r) ? (d(), b("div", Ee, [
              L(e.$slots, O(r))
            ])) : (d(), b("div", Ue, [
              me(r) ? (d(), b("div", {
                key: 0,
                class: c(X)
              }, [
                L(e.$slots, T(r))
              ])) : m("", !0)
            ]))
          ], 2),
          he(r) ? (d(), b("div", {
            key: 0,
            class: c(ue.value)
          }, [
            M(r) ? (d(), b("div", {
              key: 0,
              class: c(be(r))
            }, [
              L(e.$slots, G(r))
            ], 2)) : m("", !0),
            j(r) ? (d(), b("div", Ve, [
              L(e.$slots, H(r))
            ])) : m("", !0),
            ge(r) ? (d(), b("div", {
              key: 2,
              class: c(X)
            }, [
              L(e.$slots, T(r))
            ])) : m("", !0)
          ], 2)) : m("", !0)
        ], 14, Re))), 128))
      ], 10, Te)
    ], 2));
  }
});
export {
  je as default
};
